import React, { useState, useEffect } from 'react';
import './Testimonials.css';

const testimonials = [
  {
    name: 'Nurul Ain Binti Razak',
    country: '🇬🇧 University of Manchester, UK',
    course: 'BSc Computer Science',
    text: 'EduGlobe made the whole process feel effortless. From shortlisting universities to my visa approval — they were with me every step. I\'m now thriving at Manchester!',
    avatar: 'NA',
    stars: 5,
  },
  {
    name: 'Wei Jian Lim',
    country: '🇨🇦 University of Toronto, Canada',
    course: 'MBA – Finance',
    text: 'I was confused about which Canadian university to choose. EduGlobe\'s counsellors were honest and patient. Got my offer in 3 weeks. Visa approved first try!',
    avatar: 'WJ',
    stars: 5,
  },
  {
    name: 'Priya Nair',
    country: '🇦🇺 Monash University, Australia',
    course: 'Master of Engineering',
    text: 'The scholarship guidance alone saved me RM 40,000. EduGlobe\'s team knew exactly which funds I was eligible for. Couldn\'t have done it without them.',
    avatar: 'PN',
    stars: 5,
  },
  {
    name: 'Ahmad Faizal',
    country: '🇩🇪 TU Munich, Germany',
    course: 'MSc Mechanical Engineering',
    text: 'Germany felt like a dream — almost free tuition! EduGlobe helped me navigate German bureaucracy and language requirements. Now studying at one of the best unis in Europe.',
    avatar: 'AF',
    stars: 5,
  },
  {
    name: 'Siti Hajar Mohamad',
    country: '🇮🇪 Trinity College Dublin, Ireland',
    course: 'LLB Law',
    text: 'Professional, responsive, and genuinely caring. My counsellor replied to messages even on weekends. The pre-departure briefing made me feel so prepared. 10/10!',
    avatar: 'SH',
    stars: 5,
  },
  {
    name: 'Rajesh Kumar',
    country: '🇺🇸 Arizona State University, USA',
    course: 'BSc Data Science',
    text: 'EduGlobe found me a university I never knew existed — perfect fit for my profile and budget. My F1 visa was approved in 5 days. Absolutely incredible service!',
    avatar: 'RK',
    stars: 5,
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setActive(a => (a + 1) % testimonials.length), 5000);
    return () => clearInterval(t);
  }, []);

  const t = testimonials[active];

  return (
    <section className="testimonials" id="testimonials">
      <div className="section-inner">
        <div className="section-header">
          <span className="section-tag">Student Stories</span>
          <h2 className="section-title">Real Students, <span className="gold-text">Real Results</span></h2>
          <p className="section-sub">Don't take our word for it — hear from students we've helped reach their dreams.</p>
        </div>

        <div className="testimonial-showcase">
          <div className="testi-main">
            <div className="testi-stars">{'★'.repeat(t.stars)}</div>
            <p className="testi-quote">"{t.text}"</p>
            <div className="testi-author">
              <div className="testi-avatar">{t.avatar}</div>
              <div>
                <div className="testi-name">{t.name}</div>
                <div className="testi-uni">{t.country}</div>
                <div className="testi-course">{t.course}</div>
              </div>
            </div>
          </div>

          <div className="testi-dots">
            {testimonials.map((_, i) => (
              <button
                key={i}
                className={`testi-dot ${i === active ? 'active' : ''}`}
                onClick={() => setActive(i)}
                aria-label={`Testimonial ${i + 1}`}
              />
            ))}
          </div>

          <div className="testi-thumbs">
            {testimonials.map((tt, i) => (
              <button
                key={i}
                className={`testi-thumb ${i === active ? 'active' : ''}`}
                onClick={() => setActive(i)}
              >
                <div className="thumb-avatar">{tt.avatar}</div>
                <div className="thumb-name">{tt.name.split(' ')[0]}</div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
